import React from "react";

const Version = () => {
  return (
    <p>v{process.env.REACT_APP_VERSION}</p>
  );
};

export default Version;
